export default __webpack_public_path__ + "static/media/Photo College.fe44429a.png";